module.exports = __webpack_public_path__ + "static/media/DSC_0495.3d92cf89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0495.jpg
// module id = 670
// module chunks = 0